import {
  ApolloClient,
  InMemoryCache
} from '@apollo/client';
import Mutation from './mutations';
import configurator from './configuratorState';
import appHandlers from '../utils/appHandlers';
import { ENABLE_NEW_CONFIGURATOR } from 'client/settings';

/*
  Get the current region from the URL

  Supports:
    dev-web-cn.ffau.to
    faradayfuturecn.com
    localhost:xxxx/cn/
*/
const region = /(-cn.ffau.to|faradayfuturecn.com|(:[\d]{4,5}|.to|.com)\/cn)/.test(window?.location?.href) ? 'CN' : 'US';

const isV3 = /^\/(us|cn)\/design/.test(window?.location?.pathname);

let source = 'Web';

if (appHandlers.isMobile()) {
  source = appHandlers.isAndroid() ? 'Android' : 'iOS';
}

let headers = { region, source };

if (ENABLE_NEW_CONFIGURATOR && isV3) {
  headers = {
    ...headers,
    'order-version': '3',
    'customer-version': '2',
    'configuration-version': '2',
  };
}

const client = new ApolloClient({
  uri: `${window._env_.REACT_APP_GRAPHQL_DOMAIN || ''}/graphql`,
  cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
  clientState: {
    defaults: {
      configurator
    },
    resolvers: {
      // Mutation is capitalized
      Mutation
    }
  },
  headers,
});

export default client;
